/**
 * @fileoverview Cliente API unificado – reexporta el adaptador avanzado con gestión
 * de tokens (ApiClientAdapter) para utilizar rotación de formatos y sesión backend.
 * 
 * IMPORTANTE: Este módulo garantiza que todas las llamadas a la API usen URLs absolutas
 * en formato correcto según el entorno (Firebase Hosting vs dominio personalizado).
 */
import apiClient from '../infrastructure/http/apiClient';
import appConfig from '../infrastructure/config/AppConfig';

// Registrar diagnóstico de la URL base que están usando todos los servicios
if (appConfig?.debug && typeof localStorage !== 'undefined') {
  try {
    localStorage.setItem('nubelytics_services_apiurl', 
      `${apiClient.getBaseUrl()} (${window.location.hostname})`);
  } catch (e) {/* Ignorar errores de localStorage */}
}

// Verificar que estamos usando el cliente API configurado correctamente
if (!apiClient || !apiClient.getBaseUrl) {
  console.error('[apiClient] Error crítico: Cliente API no inicializado correctamente');
}

export default apiClient;

